<template>
	<FooterFull :footnotes="footnotes">
		<template #additionalDisclaimer>
			<FooterSocialProof :show-business-insider="true" />
		</template>
	</FooterFull>
</template>

<script setup lang="ts">
import { appBasePath } from '@constants';
import FooterFull from '@components/footer/footer-full.vue';
import FooterSocialProof from '@components/footer/footer-social-proof.vue';

const footnotes = [
	`See the full <a class="muted text-decoration-underline" href="${appBasePath}/legal/ira-fee-payment-program">terms and conditions</a> of the Fundrise IRA Fee Payment program.`
];
</script>
